var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/~/lodash/_Symbol.js
// module id = 281
// module chunks = 0